// const URL = 'http://localhost:6001/api/';
const URL = 'https://cesty.appbites.dev/api/';
// const URL = 'https://cesty.space/api/';
// const URL = 'https://kosovogenu.com/api/';
// const URL = 'https://kosovogenu.appbit.es/api/';

const ApiConstants = {
  TOKEN: localStorage.getItem('cesty-token'),
  BASE_URL: URL,
};

export default ApiConstants;
